/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { CredentialListPageAgent, getAgent } from './agent';
import { logger as log } from '../../../common/logger';
const is = require('is_js');

const SERVICE_NAME = 'CredentialListPageService';

@injectable()
export class CredentialListPageService {
  private static instance: CredentialListPageService;
  public agent: CredentialListPageAgent;
  static displayName = 'CredentialListPageService';

  constructor(props: any = {}) {
    this.agent = getAgent();
  }
}
